var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-slick/~/json2mq/~/string-convert/camel2hyphen.js
 ** module id = 550
 ** module chunks = 0
 **/